import { Buffer } from "buffer"; //or 'buffer/', with trailing slash

window.global = window;
window.Buffer = Buffer;
